import { render, staticRenderFns } from "./productInformation.vue?vue&type=template&id=20aeca78&scoped=true"
import script from "./productInformation.vue?vue&type=script&lang=js"
export * from "./productInformation.vue?vue&type=script&lang=js"
import style0 from "./productInformation.vue?vue&type=style&index=0&id=20aeca78&prod&scoped=true&lang=scss"
import style1 from "./productInformation.vue?vue&type=style&index=1&id=20aeca78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aeca78",
  null
  
)

export default component.exports